import update from 'immutability-helper';

// history

export const historyDataSelector = state => {
    return state.history.data.map((entry, index) => {
        return update(entry, { $merge: { key: `${entry.id}-${index}` } });
    });
};
